import services from './../../services/service'; // Service Class
import SecondHeader from './../Second-Header/index.vue'; // Second Header
import MainFooter from './../Main-Footer/index.vue'; // Main Footer
let service = new services();

export default {
    name: 'Cnpro',
    data () {
        return {
            user: {},
            cnpros: {},
            cnpro: {},
            cnsurveys: {},
            request: {},
            activeRequest: false,
            search: {},
            search_result: "",
            search_message: "",
            panelFlag: false,
            addFlag: false,
            img_url: service.imageURL,
            reviews: {},
            review: {},
            rate: ""
        }
    },
    components: {
        'second-header': SecondHeader,
        'main-footer': MainFooter
    },
    computed: {
        rateValue: {
            get(){
                //this function will determine what is displayed in the input
                return this.rate;
            },
            set(newVal){
                //this function will run whenever the input changes
                this.rate = newVal;
                this.rateCnpro();
            }
        }
    },
    methods: {
        //settings
        preset() {
            var credentials = {
                session_key: localStorage.getItem("cityneeds_token")
            } 
           if(credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(response => {
                    if(response.body.status == 200) {
                        let data = response.body.data;
                        data.forEach(function(element) {
                            this.user.user_id = element.user_id;
                            //special case for profile
                            service.getUser(this, element.user_id).then(data => {
                                if(data.body.status == 200) {
                                    this.user = data.body.data;
                                    this.getSearchCnpro();
                                }
                            }).catch((err) => {
                                if(err) {
                                   // toastr.error('Sorry, could not process information', 'Warning!');
                                }
                            })
                         //../special case for profile
                        }, this);
                        }else {
                            this.$router.push('login');
                      }
                }).catch((err) => {
                    if(err) {
                     this.$router.push('login');
                    }
                })
            }else {
                this.$router.push('login');
            }
            
        },

        //--//settings

        //cnpros
        setComponent(cnpro) {
              
        },

        saveComponent(component) {
            this.cnpro = component;

            var credentials = {
                save_category: 1, // 1 for cnpros
                save_business: 0, //not a business
                save_cnpro: this.cnpro.cnpro_id,
                save_user: this.user.user_id || 'nill'
            }
            service.saveListing(this, credentials).then(function(data) {
            if(data.body.status == 201) {
                toastr.success('CNpro Saved!!', 'Success!');
            }else if(data.body.status == 400) {
                toastr.error('Sorry, could not process information', 'Warning!');        
            }else if(data.body.status == 500) {
               toastr.error(data.body.message, 'Warning!');  
            }else {
                toastr.error('Please Log In to Save', 'Warning!');        
            }
            })
        },

         
        setCnpro() {
             
           
        },
       
        moveToPlans(){
            localStorage.setItem("cityneeds_request_plans","cnpro");
            this.$router.push('pricing');
        },

        // getSearchCnpro() {
        //     let check_cnpro = localStorage.getItem("cityneeds_search_cnpro");
        //     if(check_cnpro != null){
        //         var credentials = {
        //             data_item: localStorage.getItem("cityneeds_search_cnpro")
        //         }
        //         //localStorage.removeItem("cityneeds_search_cnpro"); //remove
        //         localStorage.removeItem("cityneeds_search_city"); 
        //         localStorage.removeItem("cityneeds_search_keywords"); 
        //         localStorage.removeItem("cityneeds_search_type");
        //         service.getDataItem(this, credentials, 1).then(function(data) {
        //         if(data.body.status == 200) {
        //             //get the cnpro
        //             service.getCnpro(this, data.body.data).then(data2 => {
        //             if(data2.body.status == 200) {
        //                 this.cnpro = data2.body.data;
        //                 this.panelFlag = true;
        //                 this.checkActiveRequest();
        //             }
        //             }).catch((err) => {
        //                 if(err) {
        //                     //toastr.error('Sorry, could not process information', 'Warning!');
        //                 }
        //             })
                
        //         }else if(data.body.status == 400) {
        //         //do something here like redirect to advertised data 
        //         this.search_message = "Sorry Could not get the Information of entry yet";            
        //         }
        //         })
        //     }else{
        //        this.$router.push("cnpros");
        //     }
            
        // },  
        
        getSearchCnpro() {
            let check_cnpro = this.$route.query.context;
            if(check_cnpro != null){
               
                //remove
                //localStorage.removeItem("cityneeds_search_cnpro"); 
                // localStorage.removeItem("cityneeds_search_city"); 
                // localStorage.removeItem("cityneeds_search_keywords"); 
                // localStorage.removeItem("cityneeds_search_type");
                //remove


                 service.searchCnpro(this, this.$route.query.context).then(data2 => {
                    if(data2.body.status == 200) {
                        this.cnpro = data2.body.data;
                        this.panelFlag = true;
                        this.checkActiveRequest();
                    }
                }).catch((err) => {
                    if(err) {
                        //toastr.error('Sorry, could not process information', 'Warning!');
                    }
                })
            }else{
               this.$router.push("cnpros");
            }
            
        }, 

        getCnpro(cnpro) {
           service.getCnpro(this, cnpro).then(data => {
                if(data.body.status == 200) {
                    this.cnpro = data.body.data;
                }
            }).catch((err) => {
                if(err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },

        //--//cnpro
        
        //quotes

        requestQuote() {
            var credentials = {
                contract_contractor: this.user.user_id,
                contract_cnpro: this.cnpro.cnpro_id,
                contract_request_details: this.request.details || ""
            }
            let navi = this.$router;
            if(credentials.contract_contractor != null || credentials.contract_cnpro != null) {
                service.requestQuote(this, credentials).then(data => {
                    if(data.body.status == 201) {
                        toastr.success("Message Sent!", "Success!");
                        this.activeRequest = true;
                    }else {
                        toastr.error('Sorry, could not request Quote', 'Warning!');
                    }
                }).catch((err) => {
                    if(err) {
                        toastr.error('Sorry, could not process information', 'Warning!');
                    }
                })
            }else {
                toastr.error('Kindly fill all fields', 'Warning!');
            }
        },

        checkActiveRequest(){
            var credentials = {
                contract_contractor: this.user.user_id,
                contract_cnpro: this.cnpro.cnpro_id,
                //contract_status: 3 //contract requested 
            }
            service.checkCnproContractRequest(this, credentials).then(data => {
                if(data.body.status == 200) {
                    this.activeRequest = true;
                }
                }).catch((err) => {
                    if(err) {
                      //  toastr.error('Sorry, could not process information', 'Warning!');
                    }
            })
        },
        //--//quotes

        //reviews

        submitReview() {
            var credentials = {
                review_category: 1, //cnpro review
                review_review: this.review.review,
                review_cnpro: this.cnpro.cnpro_id,
                review_business: 0,
                review_user: this.user.user_id

            }
            let navi = this.$router;
            if(credentials.review_user != null || credentials.review_review != null) {
                service.submitReview(this, credentials).then(data => {
                    if(data.body.status == 201) {
                        toastr.success("Review Submitted!", "Success!");
                    }else {
                        toastr.error('Sorry, could not submit Review', 'Warning!');
                    }
                }).catch((err) => {
                    if(err) {
                        toastr.error('Sorry, could not process information', 'Warning!');
                    }
                })
            }else {
                toastr.error('Kindly fill all fields', 'Warning!');
            }
        },
        //--//reviews

        //rate
        rateCnpro() {
            var credentials = {
                rating_category: 1, //cnpro rate
                rating_rate: this.rate,
                rating_cnpro: this.cnpro.cnpro_id,
                rating_business: 0,
                rating_user: this.user.user_id

            }
            let navi = this.$router;
            if(credentials.rating_user != null || credentials.rating_rate != null) {
                service.submitRating(this, credentials).then(data => {
                    if(data.body.status == 201) {
                        toastr.success("Rated!", "Success!");
                    }else {
                        toastr.error('Sorry, could not Rate', 'Warning!');
                    }
                }).catch((err) => {
                    if(err) {
                        toastr.error('Sorry, could not process information', 'Warning!');
                    }
                })
            }else {
                toastr.error('Kindly fill all fields', 'Warning!');
            }
        },
        //--//rate

        //user
        
        
    },
    created: function(){
        localStorage.setItem("cn_prv_page","cnpro");//log current page
        this.preset();
        //this.getSearchCnpro();
    }
}


// WEBPACK FOOTER //
// ./src/components/Cnpro/script.js